module.exports = require("./mgh.d.ts");